import { React, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Translation from '../../common/translation/translation.component';
import { POWER_BI_SUBREPORT } from '../../../constants/external-constants';

window.onload = function (){
    var mainNav = document.querySelectorAll(".main-menu");   
    for (let i = 0; mainNav.length > i; i++) {
        if (window.location.pathname.includes(mainNav[i].innerText)) {
            mainNav[i].classList.add("isActive");
        }
    }
  }

function NavMainMenu({ navMenu, showNotif, customClass }) {
   
    const location = useLocation();

    var mainNav = document.querySelectorAll(".main-menu");
    var subNav = document.querySelectorAll(".sub-list");

    const [currentLocation] = useState(location.pathname)

    useEffect(() => {
        const subNav = document.querySelectorAll(".sub-list");
        subNav.forEach((el) => {
            const linkElement = el.querySelector("a");
            if (linkElement) {
                const basePath = new URL(linkElement.href).pathname;
                if (basePath === currentLocation) {
                    el.classList.add("subSelected");
                } else {
                    el.classList.remove("subSelected");
                }
            }
        });
    }, [currentLocation]);
  
    mainNav.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; mainNav.length > i; i++) {
                mainNav[i].classList.remove("isActive");
            }
            el.classList.add("isActive");
            var haveSub = document.querySelectorAll(".isActive ul li");
            if (haveSub.length === 0) {
                for (let i = 0; subNav.length > i; i++) {
                    subNav[i].classList.remove("subSelected");
                }
            }
        })
    );

    subNav.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; subNav.length > i; i++) {
                subNav[i].classList.remove("subSelected");
            }
            el.classList.add("subSelected");
        })
    );

    return (
        <div className={`external-nav-menu ${customClass}`}>
            <ul className="external-nav-main-menu">
                {navMenu[1].ShowNav && showNotif &&
                    (
                        <div className="request-header-tab">
                            <div className={`request-approval ${navMenu?.[0]?.ShowNav ? "" : "request-approval-adjust-left"}`}>
                                <h1 className="request-approval-label">{navMenu[1].NotifApprovalCount}</h1>
                            </div>
                        </div>
                    )}
                {navMenu.map((item, id) => (
                    item.ShowNav ?
                    <li key={id} className={`main-menu ${item.isActive ? "isActive" : ""}`}>
                        <Link to={item.href}><Translation translationKey={item.title} /></Link>
                        {item.subMenu?.length >= 0? <ul
                            className={
                                typeof item.subMenu !== "undefined" && item.subMenu != null
                                    ? "external-nav-sub-menu"
                                    : ""}>
                            {typeof item.subMenu !== "undefined" && item.subMenu != null
                                ? item.subMenu.map((subItem, subId) => (
                                    subItem.isShowSubMenu ? <li
                                        key={subId}
                                        className={`sub-list ${subItem.isActive ? "subSelected" : ""
                                            }`}>
                                        <div className="sub-nav-container">
                                            { subItem.subName == POWER_BI_SUBREPORT ?
                                                <a href={subItem.href} target="_blank"><Translation translationKey={subItem.subName} /></a>
                                                : <Link to={subItem.href}><Translation translationKey={subItem.subName} /></Link>
                                            }
                                        </div>
                                    </li> : ""
                                ))
                                : ""}
                        </ul> : ""}
                    </li> : null
                ))}
            </ul>
        </div>
    )
}

export default NavMainMenu;